<ng-content [class.full-screen]="isFullScreen">
  <div class="drag-drop-zone"
       [class.disabled]="isGeneratingSchema"
       [class.hidden]="isMinimized"
       draggable="false">


    <div class="file-picker-wrapper">
      <!-- Secondary Toolbar for Search and View Toggle -->
      <div class="secondary-toolbar d-flex align-items-center justify-content-between" *ngIf="!isMinimized">
        <div class="upload-button-container">
          <button class="btn upload-documents-btn" (click)="triggerFileUpload()" [disabled]="isGeneratingSchema">
            <img src="assets/icons/upload.svg" alt="Upload" class="upload-icon">
            <span class="full-text">UPLOAD DOCUMENTS</span>
            <span class="short-text">UPLOAD</span>
          </button>
          <input
            #fileInput
            type="file"
            class="visually-hidden"
            [disabled]="isGeneratingSchema"
            (change)="handleInputChange($event)"
            [accept]="valid_files"
            multiple
          />
        </div>
        <div class="search-bar">
          <input
            type="text"
            [value]="searchSubject | async"
            (input)="onSearchInput($event)"
            class="form-control"
            placeholder="Search files..."
          />
        </div>
        <div class="view-toggle">
          <!-- Sort and Filter buttons temporarily hidden for future redesign -->
          <div class="sort-button" 
               [class.active]="sortActive()" 
               (click)="toggleSort()"
               style="display: none;">
            <div class="sort-icon">
              <img *ngIf="!sortActive()" src="assets/icons/sort-asc.svg" alt="Sort Ascending">
              <img *ngIf="sortActive()" src="assets/icons/sort-desc.svg" alt="Sort Descending">
            </div>
          </div>
          <div class="filter-button" 
               [class.active]="filterActive()" 
               (click)="toggleFilter()">
            <div class="filter-icon">
              <img src="assets/img/icons/funnel.svg" alt="Filter" class="funnel-icon">
            </div>
          </div>
          <div class="slide-toggle" (click)="toggleViewMode()">
            <div class="toggle-track">
              <span class="material-icons track-icon list-icon">format_list_bulleted</span>
              <div class="toggle-thumb" [class.active]="viewMode === 'grid'">
                <span class="material-icons thumb-icon">{{ viewMode === 'grid' ? 'grid_view' : 'format_list_bulleted' }}</span>
              </div>
              <span class="material-icons track-icon grid-icon">grid_view</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!isMinimized || isFullScreen" class="file-picker-content"
           [class.drag-over]="isDragOver">
        <div *ngIf="viewMode ==='grid'" class="grid-container">
          <ng-container *ngIf="filesCurrentlyUploading > 0">
            <div
              class="loading-block card border rounded-3 overflow-hidden position-relative mt-0"
              *ngFor="let _ of uploadingSlots; let i = index"
              [ngClass]="i === 0 ? 'border-purple border-2' : ''"
            >
              <div class="position-relative bg-light d-flex flex-column align-items-center justify-content-center h-100">
                <div class="spinner-border spinner-border-sm text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </ng-container>

          <div *ngFor="let file of itemsToShow(); index as file_index" class="thumbnail-wrapper d-flex flex-column align-items-center" 
               (click)="selectFile(file_index)"
               [ngClass]="{
                 'selected': selected_file_index == file_index,
               }">
            <div class="thumbnail-image-container position-relative cursor-pointer" 
                 [class.menu-active]="activeFileMenu === file.id">
              <img
                *ngIf="file.image?.url"
                [src]="file.image?.url"
                class="thumbnail-image"
                [alt]="file.fileName"
              />
              <!-- File type icon at top left -->
              <div class="file-type-icon position-absolute" *ngIf="!file.isStructured">
                <img src="assets/img/icons/unstructured-file.png" alt="Unstructured file" class="file-type-icon-img">
              </div>
              <div class="file-type-icon position-absolute" *ngIf="file.isStructured && !file.status">
                <img src="assets/img/icons/structured-file.png" alt="Structured file" class="file-type-icon-img">
              </div>
              
              <!-- File Menu Button -->
              <div class="file-menu-button position-absolute" (click)="toggleFileMenu($event, file.id)">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="3" cy="8" r="1.5" fill="currentColor"/>
                  <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
                  <circle cx="13" cy="8" r="1.5" fill="currentColor"/>
                </svg>
                
                <!-- File Menu Dropdown -->
                <div class="file-menu position-absolute" *ngIf="activeFileMenu === file.id">
                  <!-- File Type Header -->
                  <div class="file-menu-header">
                    <img src="assets/img/icons/file-type.svg" alt="File Type">
                    <span>File type: {{ getFileType(file.fileName) }}</span>
                  </div>
                  <div class="file-menu-separator"></div>
                  <div class="file-menu-item" (click)="onRenameFile($event, file)">
                    <img src="assets/img/icons/rename.svg" alt="Rename">
                    <span>Rename</span>
                  </div>
                  <div class="file-menu-item" (click)="onDownloadFile(file)">
                    <img src="assets/img/icons/download.svg" alt="Download">
                    <span>Download</span>
                  </div>
                  <div class="file-menu-item" (click)="onDeleteFile(file)">
                    <img src="assets/img/icons/delete.svg" alt="Delete">
                    <span>Delete</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Rename Input -->
            <div class="thumbnail-filename text-truncate text-center" *ngIf="isRenaming !== file.id" [title]="file.fileName">
              {{ file.fileName }}
            </div>
            <div class="rename-input-container px-3" *ngIf="isRenaming === file.id">
              <input 
                type="text" 
                [(ngModel)]="newFileName" 
                class="form-control rename-input"
                (keydown.enter)="confirmRename(file)"
                (keydown.escape)="cancelRename()"
                (click)="$event.stopPropagation()"
                autofocus
              >
              <div class="rename-buttons">
                <button class="icon-button icon-button-filled" (click)="confirmRename(file)">
                  <i class="bi bi-check"></i>
                </button>
                <button class="icon-button icon-button-outline" (click)="cancelRename()">✕</button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="viewMode === 'list'" class="list-view w-100 p-3">
          <ul class=" file-list">
              <ng-container *ngIf="filesCurrentlyUploading > 0">
                <li
                  class="list-group-item file-item d-flex align-items-center gap-3"
                  *ngFor="let _ of uploadingSlots; let i = index"
                  [ngClass]="i === 0 ? 'border-purple border-2' : ''"
                >
                  <div class="flex-grow-1">
                    <div class="small text-muted d-flex align-items-center">
                      <div class="spinner-border spinner-border-sm me-2" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <span >Uploading file {{ i + 1 }}...</span>
                    </div>
                  </div>
                </li>
              </ng-container>
              <ul class="list-group file-list">
                <li
                  class="list-group-item file-item d-flex align-items-center gap-3"
                  *ngFor="let file of itemsToShow(); index as file_index"
                  (click)="selectFile(file_index)"
                  [ngClass]="{
                   'border-purple border-2': selected_file_index == file_index,
                   'menu-active': activeFileMenu === file.id
                  }">
                  <span class="material-symbols-outlined me-2">insert_drive_file</span>

                <div class="flex-grow-1 text-truncate row align-items-center">
                    <div class="file-name col-6" *ngIf="isRenaming !== file.id">{{ file.fileName }}</div>
                    <div class="rename-input-container-list col-6" *ngIf="isRenaming === file.id">
                      <input 
                        type="text" 
                        [(ngModel)]="newFileName" 
                        class="form-control rename-input-list"
                        (keydown.enter)="confirmRename(file)"
                        (keydown.escape)="cancelRename()"
                        (click)="$event.stopPropagation()"
                        autofocus
                      >
                      <div class="rename-buttons-list me-2">
                        <button class="icon-button icon-button-filled" (click)="confirmRename(file)">
                          <i class="bi bi-check"></i>
                        </button>
                        <button class="icon-button icon-button-outline" (click)="cancelRename()">✕</button>
                      </div>
                    </div>
                    <div class="file-meta small text-muted d-flex gap-2 col-5">
                      <span class="file-size">
                        {{ ((file?.sizeKb || 0) / 1024) | number:'1.2-2' }} MB
                      </span>
                      <span class="upload-date">
                        Uploaded: {{ file.uploadedAt ? (file.uploadedAt | date:'dd/MM/YY') : 'no data' }}
                      </span>
                    </div>
                </div>
                
                <!-- File Menu Button for List View -->
                <div class="file-menu-button-list position-relative" (click)="toggleFileMenu($event, file.id)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="3" cy="8" r="1.5" fill="currentColor"/>
                    <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
                    <circle cx="13" cy="8" r="1.5" fill="currentColor"/>
                  </svg>
                  
                  <!-- File Menu Dropdown for List View -->
                  <div class="file-menu file-menu-list position-absolute" *ngIf="activeFileMenu === file.id">
                    <!-- File Type Header -->
                    <div class="file-menu-header">
                      <img src="assets/img/icons/file-type.svg" alt="File Type">
                      <span>File type: {{ getFileType(file.fileName) }}</span>
                    </div>
                    <div class="file-menu-separator"></div>
                    <div class="file-menu-item" (click)="onRenameFile($event, file)">
                      <img src="assets/img/icons/rename.svg" alt="Rename">
                      <span>Rename</span>
                    </div>
                    <div class="file-menu-item" (click)="onDownloadFile(file)">
                      <img src="assets/img/icons/download.svg" alt="Download">
                      <span>Download</span>
                    </div>
                    <div class="file-menu-item" (click)="onDeleteFile(file)">
                      <img src="assets/img/icons/delete.svg" alt="Delete">
                      <span>Delete</span>
                    </div>
                  </div>
                </div>
                
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Filter Window -->
  <div class="filter-window" [class.show]="filterActive()" *ngIf="filterActive()">
    <div class="filter-content">
      <!-- Upload Date Section -->
      <div class="filter-section">
        <div class="filter-header">
          <h3 class="filter-title">Upload Date</h3>
          <button class="reset-btn" (click)="resetUploadDateFilter()">Reset</button>
        </div>
        <div class="filter-options">
          <button class="filter-option" [class.active]="uploadDateFilter === 'newest'" (click)="setUploadDateFilter('newest')">NEWEST TO OLDEST</button>
          <button class="filter-option" [class.active]="uploadDateFilter === 'oldest'" (click)="setUploadDateFilter('oldest')">OLDEST TO NEWEST</button>
        </div>
      </div>

      <!-- Structuring Date Section -->
      <div class="filter-section">
        <div class="filter-header">
          <h3 class="filter-title">Structuring Date</h3>
          <button class="reset-btn" (click)="resetStructuringDateFilter()">Reset</button>
        </div>
        <div class="filter-options">
          <button class="filter-option" [class.active]="structuringDateFilter === 'newest'" (click)="setStructuringDateFilter('newest')">NEWEST TO OLDEST</button>
          <button class="filter-option" [class.active]="structuringDateFilter === 'oldest'" (click)="setStructuringDateFilter('oldest')">OLDEST TO NEWEST</button>
        </div>
      </div>

      <!-- Alphanumeric Section -->
      <div class="filter-section">
        <div class="filter-header">
          <h3 class="filter-title">Alphanumeric</h3>
          <button class="reset-btn" (click)="resetAlphanumericFilter()">Reset</button>
        </div>
        <div class="filter-options">
          <button class="filter-option" [class.active]="alphanumericFilter === 'az'" (click)="setAlphanumericFilter('az')">A > Z</button>
          <button class="filter-option" [class.active]="alphanumericFilter === 'za'" (click)="setAlphanumericFilter('za')">Z > A</button>
        </div>
      </div>

      <!-- File Size Section -->
      <div class="filter-section">
        <div class="filter-header">
          <h3 class="filter-title">File Size</h3>
          <button class="reset-btn" (click)="resetFileSizeFilter()">Reset</button>
        </div>
        <div class="filter-options">
          <button class="filter-option" [class.active]="fileSizeFilter === 'small'" (click)="setFileSizeFilter('small')">SMALL TO BIG</button>
          <button class="filter-option" [class.active]="fileSizeFilter === 'big'" (click)="setFileSizeFilter('big')">BIG TO SMALL</button>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="filter-actions">
        <button class="reset-all-btn" (click)="resetAllFilters()">RESET ALL</button>
        <button class="apply-filters-btn" (click)="applyFiltersAndClose()">APPLY FILTERS ({{ activeFiltersCount() }})</button>
      </div>
    </div>
  </div>
  
  <!-- Fixed Black Horizontal Bar at Bottom -->
  <div class="fixed-black-bar d-flex align-items-center justify-content-between">
    <div class="left-section d-flex align-items-center">
      <button class="btn upload-documents-btn-black-bar" (click)="uploadMoreFilesAndExpand()" [disabled]="isGeneratingSchema" *ngIf="isMinimized">
        <img src="assets/icons/upload.svg" alt="Upload" class="upload-icon">
        <span class="full-text">UPLOAD DOCUMENTS</span>
        <span class="short-text">UPLOAD</span>
      </button>
      <!-- Hidden file input for black bar upload button -->
      <input
        #blackBarFileInput
        type="file"
        class="visually-hidden"
        [disabled]="isGeneratingSchema"
        (change)="handleInputChange($event)"
        [accept]="valid_files"
        multiple
      />
    </div>
    <div class="center-section">
      <span class="document-count">{{ docsText }}</span>
    </div>
    <div class="right-section d-flex align-items-center">
      <button class="btn btn-icon minimize-btn" (click)="toggleMinimize()" *ngIf="!isMinimized">
        <img src="assets/img/icons/minimize.svg" alt="Minimize" class="minimize-icon" width="24" height="24">
      </button>
      <button class="btn btn-icon maximize-btn" (click)="toggleMaximize()">
        <!-- Maximize icon (minimized state) -->
        <img *ngIf="maximizeState === 'minimized'"
             src="assets/img/icons/maximize.svg" 
             alt="Maximize" 
             class="maximize-icon" 
             width="24" height="24">
        
        <!-- Maximize 50% icon (thirty state) -->
        <img *ngIf="maximizeState === 'thirty'"
             src="assets/img/icons/maximize-50.svg" 
             alt="Maximize 30%" 
             class="maximize-icon" 
             width="24" height="24">
        
        <!-- Maximize 100% icon (full state) -->
        <img *ngIf="maximizeState === 'full'"
             src="assets/img/icons/maximize-100.svg" 
             alt="Maximize 100%" 
             class="maximize-icon" 
             width="24" height="24">
      </button>
    </div>
  </div>
</ng-content>

<!-- Delete File Modal -->
<ng-template #deleteFileModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        id="btn-close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="icon-stack">
        <div class="icon-main">
          <img
            src="assets/img/icons/file-type.svg"
            alt="Delete icon"
          />
          <span class="icon-status" aria-hidden="true">
            <svg
              class="trash-svg"
              width="12"
              height="13.5"
              viewBox="0 0 12 13.5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 3.5h9M4.5 3.5v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1M10 3.5l-.6 7.2a1 1 0 0 1-1 .8H3.6a1 1 0 0 1-1-.8L2 3.5M5 6v4M7 6v4"
                stroke="#FFFFFF"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
        <div>
          <h4 class="confirm-title">
            Are you sure you want to delete this file?
          </h4>
          <p class="confirm-subtext">
            "{{ fileToDelete?.fileName }}" will be permanently removed. This action cannot be undone.
          </p>
        </div>
      </div>
      <div class="button-group">
        <button
          class="btn cancel-btn text-decoration-none"
          data-bs-dismiss="modal"
          (click)="modal.close('Close click')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn delete-btn"
          id="delete-file"
          (click)="confirmDeleteFile(); modal.close('Close click')"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</ng-template>

